import moment from 'moment/moment';
import { useQuery } from '@tanstack/react-query';
import { OrganisationDashboardByUserResponse, OrganizationDashboardRequest } from '@joc/api-gateway';
import { DASHBOARD_QUERY_KEY } from 'core/constants';
import { API } from 'core/API';
import { DateRange } from '@joc/api-gateway/lib/api-client';
import { DashboardFiltersType } from '../../pages/Admin/SuperAdminDashboard';

const fetchDashboard = async ({
	filters,
}: {
	filters?: DashboardFiltersType;
}): Promise<OrganisationDashboardByUserResponse> => {
	const timeZone = `${moment().format('Z')}`;

	return API.getAdminDashboard(timeZone, {
		dateRange:
			filters?.fromDate || filters?.toDate
				? DateRange.fromJS({ fromDate: filters?.fromDate, toDate: filters?.toDate })
				: undefined,
		organizationIds: filters?.organizationIds?.length ? filters?.organizationIds : undefined,
		opportunityLocationType: filters?.opportunityLocationType?.length ? filters.opportunityLocationType : undefined,
		createdBy: filters?.createdBy?.length ? filters?.createdBy : undefined,
	} as unknown as OrganizationDashboardRequest);
};

export const useDashboard = (filters: DashboardFiltersType) =>
	useQuery<OrganisationDashboardByUserResponse, unknown>({
		queryKey: [DASHBOARD_QUERY_KEY, { filters }],
		queryFn: () => fetchDashboard({ filters }),
	});
